import { HorizontalRule } from 'components/Layout';

export const HorizontalRuleMobile = (props: { [key: string]: any }) => (
  <HorizontalRule display={['block', 'none']} height="1px" m={0} {...props} />
);
